import React, { useState, useRef, useEffect } from 'react';
import './style.css';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Container, Table, ButtonSuccess, ButtonDanger, ButtonPrimary, TopNav, NavLink, Icon, ResponsiveMenu } from './styles';

export const Home = () => {
  const history = useHistory();
  const [address, setAddress] = useState('');
  const [ean, setEan] = useState('');
  const [eanList, setEanList] = useState([]);
  const [qrCodeRead, setQrCodeRead] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isAddressInventoried, setIsAddressInventoried] = useState(false);
  const { id, periodo } = useParams();
  const addressInputRef = useRef(null);
  const eanInputRef = useRef(null);
  const [navClass, setNavClass] = useState('topnav');

  useEffect(() => {
    if (qrCodeRead && addressInputRef.current) {
      addressInputRef.current.focus();
      setQrCodeRead(false);
    }
  }, [qrCodeRead]);

  const validarEndereco = async () => {
    try {
      const response = await fetch(`https://inventario.dracherie.com.br/api_cherie/componentes_endereco/confere.php?endereco=${address}&id_loja=${id}&id_periodo=${periodo}`);
      
      if (!response.ok) {
        throw new Error(`Erro na validação: ${response.statusText} (${response.status})`);
      }
      
      const data = await response.json();
  
      // Verifica se o endereço já foi bipado
      if (data.isInventoried) {
        setIsAddressInventoried(true);
        setErrorMessage('Endereço já bipado anteriormente neste período e loja.');
      } else {
        setIsAddressInventoried(false);
        setErrorMessage('');
        eanInputRef.current.focus(); // Permitir foco no campo EAN
      }
    } catch (error) {
      console.error('Erro na validação do endereço:', error);
      setErrorMessage('Ocorreu um erro ao validar o endereço.');
    }
  };
  
  
  const handleAddressInputChange = (event) => {
    setAddress(event.target.value);
  };

  const handleEanInputChange = (event) => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      setEan(inputValue);
      if (inputValue.length !== 13 && inputValue.length > 0) {
        setErrorMessage('O EAN deve ter exatamente 13 dígitos.');
      } else {
        setErrorMessage('');
      }
    }
  };


const handleKeyDown = async (event) => {
  if (event.key === 'Enter' || event.key === 'Tab') {
    event.preventDefault();

    if (address && !ean && !errorMessage) {
      await validarEndereco();
      

      if (!isAddressInventoried) {
        eanInputRef.current.focus(); 
      }
    } else if (ean && ean.length === 13) {
      if (!isAddressInventoried) {
        setEanList((prevList) => [...prevList, ean]);
        setEan('');
        setErrorMessage('');
      } else {
        setErrorMessage('Endereço já cadastrado. Não é possível adicionar mais EANs.');
      }
    } else {
      setErrorMessage('O EAN deve ter exatamente 13 dígitos.');
    }
  }
};

  const handleRemoveEan = (indexToRemove) => {
    setEanList((prevList) => prevList.filter((_, index) => index !== indexToRemove));
  };

  const enviarDadosParaPHP = () => {
    if (!address || !eanList.length || !id || isAddressInventoried) {
      console.error('Dados inválidos para envio ou endereço não validado!');
      setErrorMessage('Por favor, valide o endereço antes de cadastrar.');
      return;
    }

    const dadosParaEnviar = {
      endereco: address,
      eanList: eanList,
      id_loja: id,
      id_periodo: periodo
    };

    fetch('https://inventario.dracherie.com.br/api_cherie/componentes_endereco/cadastrar.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dadosParaEnviar),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Resposta do PHP:', data);
        setAddress('');
        setEan('');
        setEanList([]);
      })
      .catch((error) => {
        console.error('Erro na requisição:', error);
      });
  };

  const toggleNav = () => {
    setNavClass((prevClass) => (prevClass === 'topnav' ? 'topnav responsive' : 'topnav'));
  };

  return (
    <Container>
      <div>
        <div className={navClass} id="myTopnav">
          <a href="#" className="icon" onClick={(e) => { e.preventDefault(); toggleNav(); }}>&#9776;</a>
          <Link to={`/conferencia/${id}/${periodo}`} className='link_inventario'>Conferencia</Link>
          <Link to={`/divergencia/${id}/${periodo}`} className='link_qr-code'>Divergencia</Link>
        </div>
        <br></br> <br></br>

        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <input
            type="text"
            className='inp_endereco'
            placeholder="Mire o QR Code aqui"
            ref={addressInputRef}
            value={address}
            onChange={handleAddressInputChange}
            onKeyDown={handleKeyDown} 
          />
        <h1>Endereço: {address}</h1>
        <input
          type="text"
          className='inp_ean'
          placeholder="Leia o código EAN"
          ref={eanInputRef}
          value={ean}
          onChange={handleEanInputChange}
          onKeyDown={handleKeyDown}
          disabled={isAddressInventoried}
        />
        <div>
          <Table>
            <thead >
              <tr>
                <th>N°</th>
                <th>EAN</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {eanList.map((ean, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{ean}</td>
                  <td>
                    <ButtonDanger onClick={() => handleRemoveEan(index)}>X</ButtonDanger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <ButtonSuccess className='btn_cadastrar' onClick={enviarDadosParaPHP} type="submit">Cadastrar</ButtonSuccess>
        </div>
      </div>
    </Container>
  );
};

export default Home;
